var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.94 23.94C22.2306 25.243 20.1491 25.9649 18 26C11 26 7 18 7 18C8.24389 15.6819 9.96914 13.6566 12.06 12.06M15.9 10.24C16.5883 10.0789 17.2931 9.99833 18 9.99999C25 9.99999 29 18 29 18C28.393 19.1356 27.6691 20.2047 26.84 21.19M20.12 20.12C19.8454 20.4147 19.5141 20.6511 19.1462 20.8151C18.7782 20.9791 18.3809 21.0673 17.9781 21.0744C17.5753 21.0815 17.1752 21.0074 16.8016 20.8565C16.4281 20.7056 16.0887 20.481 15.8038 20.1961C15.519 19.9113 15.2944 19.5719 15.1435 19.1984C14.9926 18.8248 14.9185 18.4247 14.9256 18.0219C14.9327 17.6191 15.0209 17.2218 15.1849 16.8538C15.3488 16.4858 15.5853 16.1546 15.88 15.88",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7L29 29",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOff);
export default __webpack_public_path__ + "static/media/icon-eye-off.15c0ad1221b2679736730433f051ffbf.svg";
export { ForwardRef as ReactComponent };